import "./App.css";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Home from "./components/home/Home";
import RedirectLoader from "./components/RedirectLoader/RedirectLoader";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PageNotFound from "./components/PageNotFound/PageNotFound";

function App() {
  return (
    <Router>
      <div className="flex flex-col gap-[20px] md:gap-[84px]  max-w-[19200px] overflow-x-hidden overflow-y-hidden sm:overflow-y-auto mx-auto  h-[100vh] sm:h-auto">
        <div className="font-inter w-full relative   flex flex-col gap-[20px] md:gap-[84px]">
          <div className="px-4 sm:px-8 lg:px-28">
            <Navbar />
          </div>

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/redirect/:s_id/:p_id" element={<RedirectLoader />} />
            <Route path="*" element={<PageNotFound/>}/>
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
